export default "__VITE_ASSET__D8M4x_Bb__"